import type { QueryClient } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import {
	createRootRouteWithContext,
	HeadContent,
	Outlet,
} from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'

import { LoadingRoute } from '@/components/common/loading-screen'
import { TailwindDevTools } from '@/components/tools/tailwind-dev-tools'
import { Toaster } from '@/components/ui/toaster/toaster'
import { TooltipProvider } from '@/components/ui/tooltip/tooltip'

import { IS_DEV } from '@/libs/configs/constant'
import { useAuth } from '@/libs/hooks/use-auth'

interface RouteContext {
	qc: QueryClient
}

export const Route = createRootRouteWithContext<RouteContext>()({
	component: Component,
	beforeLoad: async ({ preload }) => {
		if (preload) return
		await useAuth.getState().revalidateSession()
	},
	pendingComponent: LoadingRoute,
})

function Component() {
	// const matches = useMatches()

	// if (matches.some((match) => match.status === 'pending')) return null

	// const matchesWithCrumbs = matches.filter((match) =>
	// 	isMatch(match, 'loaderData.crumb')
	// )

	return (
		<TooltipProvider>
			<HeadContent />
			<Outlet />
			<Toaster position="top-center" />
			<DevTools />
		</TooltipProvider>
	)
}

// @ts-ignore
function DevTools() {
	return (
		<>
			<TailwindDevTools />
			{IS_DEV && <TanStackRouterDevtools position="bottom-right" />}
			<ReactQueryDevtools buttonPosition="bottom-right" />
		</>
	)
}
